import { Injectable } from '@angular/core'
import { CollectionRepository } from '@engineering11/web-api-firebase'
import { COLLECTIONS, IJobApplicationStage } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class CandidateApplicationStageRepository extends CollectionRepository<IJobApplicationStage> {
  COLLECTION = COLLECTIONS.CANDIDATE_APPLICATION_STAGE
}
